/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/** @param {GridQuestion} question */
export const validateGridQuestion = (question) => {
    let rowErrors = 0;
    let columnErrors = 0;
    for (const row of question?.options || []) {
        if (!row?.label || !row?.key) {
            rowErrors++;
        }
    }
    for (const column of question?.columns || []) {
        if (!column?.label || !column?.subQuestion?.key) {
            columnErrors++;
        }
    }
    if (rowErrors > 0 || columnErrors > 0) {
        return createGridErrorMessage(question, rowErrors, columnErrors);
    }
    return [];
};

/**
 * @param {GridQuestion} question
 * @param {number} rowErrors
 * @param {number} columnErrors
 */
export const createGridErrorMessage = (question, rowErrors, columnErrors) => {
    const label = question?.label ?? question?.prompt;
    const type = question?.type;
    const key = question?.key;
    let errorMessage = `Question "${key || label || type}" `;
    if (rowErrors > 0) {
        errorMessage += `has ${rowErrors} invalid row${rowErrors > 1 ? "s" : ""}`;
    }
    if (rowErrors > 0 && columnErrors > 0) {
        errorMessage += " and ";
    }
    if (columnErrors > 0) {
        errorMessage += `has ${columnErrors} invalid column${columnErrors > 1 ? "s" : ""}`;
    }
    return [errorMessage];
};
